class TilesetLayer {


    constructor(options) {

        this.options = options;
        this._mountedHook(); //初始化一次
    }

    //是否允许鼠标穿透拾取
    get allowDrillPick() {
        return this._allowDrillPick;
    }

    set allowDrillPick(val) {
        if (this._allowDrillPick == val) {
            return
        }
        this._allowDrillPick = val;
    }

    //轴方向
    get axis() {
        return this._axis;
    }

    set axis(val) {
        if (this._axis == val) {
            return
        }
        this._axis = val;
        this.updateTilesetAxis();
    }

    //模型包围球
    get boundingSphere() {
        return this._boundingSphere;
    }

    set boundingSphere(val) {
        if (this._boundingSphere == val) {
            return
        }
        this._boundingSphere = val;
    }

    //模型中心坐标
    get center() {
        return this._center;
    }

    set center(val) {
        if (this._center == val) {
            return
        }
        this._center = val;
    }

    //自定义模型着色器
    get customShader() {
        return this._customShader;
    }

    set customShader(val) {
        if (this._customShader == val) {
            return
        }
        this._customShader = val;
    }

    //是否可以编辑
    get hasEdit() {
        return this._hasEdit;
    }

    set hasEdit(val) {
        if (this._hasEdit == val) {
            return
        }
        this._hasEdit = val;
    }

    //是否正在编辑状态
    get isEditing() {
        return this._isEditing;
    }

    //是否可以调整透明度
    get hasOpacity() {
        return this._hasOpacity;
    }

    set hasOpacity(val) {
        if (this._hasOpacity == val) {
            return
        }
        this._hasOpacity = val;
    }

    //透明度，取值范围：0.0-1.0
    get opacity() {
        return this._opacity;
    }

    set opacity(val) {
        if (this._opacity == val) {
            return
        }
        this._opacity = val;

        this.updateAlpha();
    }

    //旋转方向，示例：{ x: 0, y: 0, z: 0 }
    get rotation() {
        return this._rotation;
    }

    set rotation(val) {
        if (this._rotation == val) {
            return
        }
        this._rotation = val;
    }

    //X轴上的旋转方向
    get rotation_x() {
        return this._rotation_x;
    }

    set rotation_x(val) {
        if (this._rotation_x == val) {
            return
        }
        this._rotation_x = val;
        this.updateRotation();
    }

    //Y轴上的旋转方向
    get rotation_y() {
        return this._rotation_y;
    }

    set rotation_y(val) {
        if (this._rotation_y == val) {
            return
        }
        this._rotation_y = val;
        this.updateRotation();
    }


    //Z轴上的旋转方向
    get rotation_z() {
        return this._rotation_z;
    }

    set rotation_z(val) {
        if (this._rotation_z == val) {
            return
        }
        this._rotation_z = val;
        this.updateRotation();
    }

    //缩放比例
    get scale() {
        return this._scale;
    }

    set scale(val) {
        if (this._scale == val) {
            return
        }
        this._scale = val;
        this.updateScale();
    }

    //显示隐藏状态
    get show() {
        return this._show;
    }

    set show(val) {
        if (this._show == val) {
            if (this._show && this._flyTo) {
                this.flyTo();
            }
            
            return
        }
        this._show = val;
        this._dataSource.show = this._show;
        this.addTo();
        if (this._show && this._flyTo) {
            this.flyTo();
        }
    }

    //对象添加到地图前创建一些对象的钩子方法， 只会调用一次
    _mountedHook() {
        this._autoAdd = Cesium.defaultValue(this.options.autoAdd, false); //自动加载
        this._transform = Cesium.defaultValue(this.options.transform, true); //自动加载
        this._dataSource = new Cesium.PrimitiveCollection();
        this._tileset = new Cesium.Cesium3DTileset(this.options);
        if (this._autoAdd) {
            this.addTo();
            this._show = true;
        }
        this._flyTo = Cesium.defaultValue(this.options.flyTo, false); //自动定位
        this._opts = this.options.opts || {}; //修改位置旋转等操作
        this._position = this.options.position; //修改模型位置
        this._rotation = this.options.rotation || {}; //修改模型旋转
        this._style = this.options.style; //修改3DTileStyle
        this._customShader = this.options.customShader; //修改自定义材质
        this.updatePosition();
        this.update3DTileStyle();
        this._rotation_x = Cesium.defaultValue(this._rotation.x, 0);
        this._rotation_y = Cesium.defaultValue(this._rotation.y, 0);
        this._rotation_z = Cesium.defaultValue(this._rotation.z, 0);
        if ((this._rotation_x + this._rotation_y + this._rotation_z) > 0) {
            this.updateRotation();
        }

    }

    //添加到地图上
    addTo(map) {
        if (this._isAdd) {
            return;
        }

        this._dataSource.add(this._tileset); // 
        viewer.scene.primitives.add(this._dataSource);

        this._isAdd = true;
    }

    //重新加载模型
    reload() {

    }

    //从地图上移除
    remove(destroy) {
        this._dataSource.remove(this._tileset);
        if (destroy) {
            this._dataSource.destroy();
        }

        this._isAdd = false;
    }

    //模型自动贴地计算及处理, 因为模型在设计或生产时，模型的视角中心位置不一定在0,0,0点，此方法不是唯一准确的。
    clampToGround(addHeight = 1) {

    }

    //飞行定位至图层数据所在的视角
    flyTo(options) {
        viewer.flyTo(this._tileset);
    }

    updateTilesetProp(props) {
        if (!props) {
            return;
        }
        this._tileset.readyPromise.then(function (tileset) {
            for (var prop in props) {
                tileset[prop] = props[prop];
            }
        });
    }

    //贴地
    clampToGround() {

        this._tileset.readyPromise.then(function (tileset) {
            let center = Cesium.Cartographic.fromCartesian(
                tileset.boundingSphere.center
            )
            let surface = Cesium.Cartesian3.fromRadians(
                center.longitude,
                center.latitude,
                center.height
            )
            let offset = Cesium.Cartesian3.fromRadians(
                center.longitude,
                center.latitude,
                0
            )
            let translation = Cesium.Cartesian3.subtract(
                offset,
                surface,
                new Cesium.Cartesian3()
            )
            tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
        });
    }

    getCenterPromise(callback) {
        var that = this;
        this._tileset.readyPromise.then(function (tileset) {
            var transform = undefined;
            if (Cesium.defined(tileset._root) && Cesium.defined(tileset._root.transform)) {
                transform = tileset._root.transform;
            }
            var res = that.getCenter(tileset, transform);
            callback(res);
        });
    }


    updatePosition() {
        var that = this;
        if (this._position) {
            this._tileset.readyPromise.then(function (tileset) {
                var transform = undefined;
                if (Cesium.defined(tileset._root) && Cesium.defined(tileset._root.transform)) {
                    transform = tileset._root.transform;
                }
                var _opts = that.getCenter(tileset, transform);
                _opts.x = Cesium.defaultValue(that._position.x, _opts.x);
                _opts.y = Cesium.defaultValue(that._position.y, _opts.y);
                _opts.z = Cesium.defaultValue(that._position.z, _opts.z);

                _opts.x_offset = Cesium.defaultValue(that._position.x_offset, 0);
                _opts.y_offset = Cesium.defaultValue(that._position.y_offset, 0);
                _opts.z_offset = Cesium.defaultValue(that._position.z_offset, 0);
                if (!that._center) {
                    that._center = { x: _opts.x, y: _opts.y, z: _opts.z }
                }
                var position = Cesium.Cartesian3.fromDegrees(that._center.x, that._center.y, that._center.z);
                if ((_opts.x_offset + _opts.y_offset + _opts.z_offset) > 0) {
                    position = that.getPositionTranslation(position, { x: _opts.x_offset, y: _opts.y_offset, z: _opts.z_offset });
                }

                _opts.position = position;
                that.updateMatrix(tileset, _opts);
            });
        }
    }

    update3DTileStyle() {
        if (this._style) {
            var style = new Cesium.Cesium3DTileStyle(this._style);
            this._tileset.readyPromise.then(function (tileset) {
                tileset.style = style;
            });
        }
    }

    //更新偏移量
    updateOffset(x, y, z) {
        var that = this;
        this._tileset.readyPromise.then(function (tileset) {
            var transform = undefined;
            if (Cesium.defined(tileset._root) && Cesium.defined(tileset._root.transform)) {
                transform = tileset._root.transform;
            }
            var _opts = that.getCenter(tileset, transform);
            if (!that._center) {
                that._center = { x: _opts.x, y: _opts.y, z: _opts.z }
            }
            var position = Cesium.Cartesian3.fromDegrees(that._center.x, that._center.y, that._center.z);
            var newPoint = that.getPositionTranslation(position, { x: x, y: y, z: z });
            _opts.position = newPoint;
            that.updateMatrix(tileset, _opts);
        });
    }

    //更新模型位置
    updatePositionXYZ(x, y, z) {
        var that = this;
        this._tileset.readyPromise.then(function (tileset) {
            var transform = undefined;
            if (Cesium.defined(tileset._root) && Cesium.defined(tileset._root.transform)) {
                transform = tileset._root.transform;
            }
            var _opts = that.getCenter(tileset, transform);
            _opts.x = x;
            _opts.y = y;
            _opts.z = z;

            that.updateMatrix(tileset, _opts);
            that._center = { x: x, y: y, z: z }
        });

        viewer.flyTo(that._tileset);
    }

    //旋转模型
    updateRotation() {
        var that = this;
        this._tileset.readyPromise.then(function (tileset) {

            var transform = undefined;
            if (Cesium.defined(tileset._root) && Cesium.defined(tileset._root.transform)) {
                transform = tileset._root.transform;
            }
            var _opts = that.getCenter(tileset, transform);
            _opts.rotation_x = Cesium.defaultValue(that._rotation_x, _opts.rotation_x);
            _opts.rotation_y = Cesium.defaultValue(that._rotation_y, _opts.rotation_y);
            _opts.rotation_z = Cesium.defaultValue(that._rotation_z, _opts.rotation_z);
            that.updateMatrix(tileset, _opts);
        });
    }

    updateScale() {
        var that = this;
        this._tileset.readyPromise.then(function (tileset) {
            var transform = undefined;
            if (Cesium.defined(tileset._root) && Cesium.defined(tileset._root.transform)) {
                transform = tileset._root.transform;
            }
            var _opts = that.getCenter(tileset, transform);
            _opts.scale = that._scale;
            that.updateMatrix(tileset, _opts);
        });
    }

    updateTilesetAxis() {
        var that = this;
        this._tileset.readyPromise.then(function (tileset) {
            var transform = undefined;
            if (Cesium.defined(tileset._root) && Cesium.defined(tileset._root.transform)) {
                transform = tileset._root.transform;
            }
            var _opts = that.getCenter(tileset, transform);
            _opts.axis = that._axis;
            that.updateMatrix(tileset, _opts);
        });
    }
    // "style": {
    //     "color": {
    //       "conditions": [
    //         ["(${Classification} >= 4) && (${Classification} < 5) ", "color('#DC143C')"],
    //         ["(${Classification} >= 7) && (${Classification} < 8)  ", "color('#7B68EE')"],
    //         ["(${Classification} >= 16) && (${Classification} < 17)  ", "color('#00CED1')"],
    //         ["(${Classification} >= 17) && (${Classification} < 18)  ", "color('#3CB371')"],
    //         ["(${Classification} >= 18) && (${Classification} < 19)  ", "color('#FFFF00')"],
    //         ["(${Classification} >= 19) && (${Classification} < 20)  ", "color('#FFA500')"],
    //         ["(${Classification} >= 20) && (${Classification} < 21)  ", "color('#FF6347')"]
    //       ]
    //     }
    //   },

    //更新透明度
    updateAlpha() {
        var that = this;
        this._tileset.readyPromise.then(function (tileset) {
            tileset.style = new Cesium.Cesium3DTileStyle({
                color: "color('rgba(255,255,255," + that._opacity + ")')"
            });
        });
    }

    //变换模型位置等
    updateMatrix(tileset, opts) {
        var matrix;
        //有自带世界矩阵
        if (Cesium.defined(tileset._root) && Cesium.defined(tileset._root.transform) && this._transform) {

            //平移
            var position = opts.position || Cesium.Cartesian3.fromDegrees(opts.x, opts.y, opts.z);
            matrix = Cesium.Transforms.eastNorthUpToFixedFrame(position);

            //旋转 
            var mx = Cesium.Matrix3.fromRotationX(Cesium.Math.toRadians(opts.rotation_x || 0));
            var my = Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(opts.rotation_y || 0));
            var mz = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(opts.rotation_z || 0));
            var rotationX = Cesium.Matrix4.fromRotationTranslation(mx);
            var rotationY = Cesium.Matrix4.fromRotationTranslation(my);
            var rotationZ = Cesium.Matrix4.fromRotationTranslation(mz);

            //旋转、平移矩阵相乘
            Cesium.Matrix4.multiply(matrix, rotationX, matrix);
            Cesium.Matrix4.multiply(matrix, rotationY, matrix);
            Cesium.Matrix4.multiply(matrix, rotationZ, matrix);

            //缩放
            if (opts.scale > 0 && opts.scale != 1) //缩放比例
                Cesium.Matrix4.multiplyByUniformScale(matrix, opts.scale, matrix);

            //变换轴
            if (opts.axis) matrix = this.updateAxis(matrix, opts.axis);

            tileset._root.transform = matrix;
        } else {
            //普通,此种方式[x，y不能多次更改]
            var boundingSphere = tileset.boundingSphere;
            var catographic = Cesium.Cartographic.fromCartesian(boundingSphere.center);
            var surface = Cesium.Cartesian3.fromRadians(catographic.longitude, catographic.latitude, 0.0);
            var offset = Cesium.Cartesian3.fromDegrees(opts.x, opts.y, opts.z);

            var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
            matrix = Cesium.Matrix4.fromTranslation(translation);

            tileset.modelMatrix = matrix;
        }

        this._opts = opts;
        return matrix;
    }

    //变换轴，兼容旧版本数据z轴方向不对的情况
    //如果可以修改模型json源文件，可以在json文件里面加了一行来修正："gltfUpAxis" : "Z", 
    //3dtiles相关计算常用方法
    updateAxis(matrix, axis) {
        if (axis == null) return matrix;

        var rightaxis;
        switch (axis.toUpperCase()) {
            case "Y_UP_TO_Z_UP":
                rightaxis = Cesium.Axis.Y_UP_TO_Z_UP;
                break;
            case "Z_UP_TO_Y_UP":
                rightaxis = Cesium.Axis.Z_UP_TO_Y_UP;
                break;
            case "X_UP_TO_Z_UP":
                rightaxis = Cesium.Axis.X_UP_TO_Z_UP;
                break;
            case "Z_UP_TO_X_UP":
                rightaxis = Cesium.Axis.Z_UP_TO_X_UP;
                break;
            case "X_UP_TO_Y_UP":
                rightaxis = Cesium.Axis.X_UP_TO_Y_UP;
                break;
            case "Y_UP_TO_X_UP":
                rightaxis = Cesium.Axis.Y_UP_TO_X_UP;
                break;
        }
        if (rightaxis == null) return this.originalMatrix || matrix;

        //变换前矩阵
        if (!this.originalMatrix) {
            this.originalMatrix = matrix.clone();
        }

        return Cesium.Matrix4.multiplyTransformation(matrix, rightaxis, matrix);
    }
    //获取模型的中心点信息
    getCenter(tileset, transform) {
        var result = {};

        //记录模型原始的中心点
        var boundingSphere = tileset.boundingSphere;
        var position = boundingSphere.center;
        var catographic = Cesium.Cartographic.fromCartesian(position);

        var height = Number(catographic.height.toFixed(2));
        var longitude = Number(Cesium.Math.toDegrees(catographic.longitude).toFixed(6));
        var latitude = Number(Cesium.Math.toDegrees(catographic.latitude).toFixed(6));
        result = { x: longitude, y: latitude, z: height };

        console.log("模型内部原始位置:" + JSON.stringify(result));

        //如果tileset自带世界矩阵矩阵，那么计算放置的经纬度和heading
        if (transform) {
            var matrix = Cesium.Matrix4.fromArray(tileset._root.transform);
            var pos = Cesium.Matrix4.getTranslation(matrix, new Cesium.Cartesian3());
            var wpos = Cesium.Cartographic.fromCartesian(pos);
            if (Cesium.defined(wpos)) {
                result.x = Number(Cesium.Math.toDegrees(wpos.longitude).toFixed(6));
                result.y = Number(Cesium.Math.toDegrees(wpos.latitude).toFixed(6));
                result.z = Number(wpos.height.toFixed(2));

                //取旋转矩阵
                var rotmat = Cesium.Matrix4.getMatrix3(matrix, new Cesium.Matrix3());
                //默认的旋转矩阵
                var defrotmat = Cesium.Matrix4.getMatrix3(Cesium.Transforms.eastNorthUpToFixedFrame(pos), new Cesium.Matrix3());

                //计算rotmat 的x轴，在defrotmat 上 旋转
                var xaxis = Cesium.Matrix3.getColumn(defrotmat, 0, new Cesium.Cartesian3());
                var yaxis = Cesium.Matrix3.getColumn(defrotmat, 1, new Cesium.Cartesian3());
                var zaxis = Cesium.Matrix3.getColumn(defrotmat, 2, new Cesium.Cartesian3());

                var dir = Cesium.Matrix3.getColumn(rotmat, 0, new Cesium.Cartesian3());

                dir = Cesium.Cartesian3.cross(dir, zaxis, dir);
                dir = Cesium.Cartesian3.cross(zaxis, dir, dir);
                dir = Cesium.Cartesian3.normalize(dir, dir);

                var heading = Cesium.Cartesian3.angleBetween(xaxis, dir);

                var ay = Cesium.Cartesian3.angleBetween(yaxis, dir);

                if (ay > Math.PI * 0.5) {
                    heading = 2 * Math.PI - heading;
                }
                result.rotation_x = 0;
                result.rotation_y = 0;
                result.rotation_z = Number(Cesium.Math.toDegrees(heading).toFixed(1));

                result.heading = result.rotation_z; //兼容v1老版本

                console.log("模型内部世界矩阵:" + JSON.stringify(result));
            }
        }

        return result;
    }
    //获取点的offest平移矩阵后点
    getPositionTranslation(position, offest, degree, type, fixedFrameTransform) {
        fixedFrameTransform = fixedFrameTransform || Cesium.Transforms.eastNorthUpToFixedFrame;

        var rotate = Cesium.Math.toRadians(-Cesium.defaultValue(degree, 0)); //转成弧度

        type = (type || "z").toUpperCase();
        var _normal = Cesium.Cartesian3["UNIT_" + type];

        var quaternion = Cesium.Quaternion.fromAxisAngle(_normal, rotate); //quaternion为围绕这个z轴旋转d度的四元数
        var rotateMatrix3 = Cesium.Matrix3.fromQuaternion(quaternion); //rotateMatrix3为根据四元数求得的旋转矩阵

        var pointCartesian3 = new Cesium.Cartesian3(Cesium.defaultValue(offest.x, 0), Cesium.defaultValue(offest.y, 0), Cesium.defaultValue(offest.z, 0)); //point的局部坐标
        var rotateTranslationMatrix4 = Cesium.Matrix4.fromRotationTranslation(rotateMatrix3, Cesium.Cartesian3.ZERO); //rotateTranslationMatrix4为旋转加平移的4x4变换矩阵，这里平移为(0,0,0)，故填个Cesium.Cartesian3.ZERO
        Cesium.Matrix4.multiplyByTranslation(rotateTranslationMatrix4, pointCartesian3, rotateTranslationMatrix4); //rotateTranslationMatrix4 = rotateTranslationMatrix4  X  pointCartesian3
        var originPositionCartesian3 = Cesium.Ellipsoid.WGS84.cartographicToCartesian(Cesium.Cartographic.fromCartesian(position)); //得到局部坐标原点的全局坐标
        var originPositionTransform = fixedFrameTransform(originPositionCartesian3); //m1为局部坐标的z轴垂直于地表，局部坐标的y轴指向正北的4x4变换矩阵
        Cesium.Matrix4.multiplyTransformation(originPositionTransform, rotateTranslationMatrix4, rotateTranslationMatrix4); //rotateTranslationMatrix4 = rotateTranslationMatrix4 X originPositionTransform
        var pointCartesian = new Cesium.Cartesian3();
        Cesium.Matrix4.getTranslation(rotateTranslationMatrix4, pointCartesian); //根据最终变换矩阵m得到p2
        return pointCartesian;
    }

}


export default TilesetLayer;